import { api } from 'utils/hooks/useApi';
import { get } from 'lodash';

export const getVersionAndLabel = (): any =>
  api()
    .get(`/portal-api/about/getVersionAndLabel`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
